import dayjs from "dayjs";

export function getInitials(firstName?: string, lastName?: string): string {
  const first = firstName?.[0] ?? "";
  const last = lastName?.[0] ?? "";
  return (first + last).toUpperCase() || "—";
}

export function formatTimelineRange(
  deadlineFrom?: string,
  deadlineTo?: string
): string {
  if (!deadlineFrom || !deadlineTo) {
    return "—";
  }

  const from = dayjs(deadlineFrom);
  const to = dayjs(deadlineTo);

  if (!from.isValid() || !to.isValid()) {
    return "—";
  }

  return `${from.format("MMM D, HH:mm A")} → ${to.format("MMM D, HH:mm A")}`;
}
